import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useStores } from 'index';
import { useNavigate } from 'react-router-dom';
import { AdminPagesRelativeRoutes } from 'Routes';
import { CreateOrganizationPayload, UpdateOrganizationPayload, AdminOrganizationResponse } from 'types/admin/organizations';
import { getErrorMessage } from 'utilities/ErrorHelper';

type Callbacks = {
  mutationFn?: (organization: CreateOrganizationPayload | UpdateOrganizationPayload) => Promise<AdminOrganizationResponse | null>;
  onMutate?: () => void;
  onSettled?: () => void;
};

export const useSaveOrganization = (organizationId?: string, callbacks?: Callbacks) => {
  const queryClient = useQueryClient();
  const notificationsStore = useStores().notificationStore;
  const navigate = useNavigate();

  return useMutation({
    mutationFn: callbacks?.mutationFn,
    onMutate: callbacks?.onMutate,
    onSuccess: async (response) => {
      if (response) {
        navigate(`/Admin/${AdminPagesRelativeRoutes.OrganizationsEditor}/${response.id}`);
      }
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['adminOrganizationsList'] }),
        queryClient.invalidateQueries({ queryKey: ['organizationsList'] }),
        organizationId && queryClient.invalidateQueries({ queryKey: ['adminOrganization', organizationId] }),
        organizationId && queryClient.invalidateQueries({ queryKey: ['numberOfInvitesLeft', organizationId] }),
      ]);
      notificationsStore.addToast('success', 'Organization has been saved successfully', 'success');
    },
    onError: (error) => notificationsStore.addToast('error', getErrorMessage(error), 'error'),
    onSettled: callbacks?.onSettled,
  });
};
